'use client';

import * as React from 'react';

/**
 * Set by a surface that is already an open overlay, such as the Navbar
 * drawer. A Popover inside it lays out its header, body, and footer in place
 * instead of opening a second overlay on top.
 */
const PopoverInlineContext = React.createContext(false);

export const PopoverInlineProvider = PopoverInlineContext.Provider;

export function usePopoverInline(): boolean {
  return React.useContext(PopoverInlineContext);
}
